import { Typography } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import { ProgressLoaderStyle } from "./Loader.style";

const ProgressLoader = ({
  label,
  style,
}: {
  label?: string;
  style?: object;
}) => {
  return (
    <ProgressLoaderStyle style={style}>
      <CircularProgress data-testid="progress-loader" />
      {label && <Typography>{label}</Typography>}
    </ProgressLoaderStyle>
  );
};

export default ProgressLoader;
